import React, { useEffect, useRef, useState } from 'react';

/**
 * Görünür olduğunda sayan istatistik değeri.
 * "3 sn" → 0'dan 3'e, "%100" → 0'dan 100'e sayar; sayısal olmayan kısımlar korunur.
 */
function CountUpValue({ value }: { value: string }) {
  const ref = useRef<HTMLDivElement>(null);
  const [display, setDisplay] = useState(value);
  const started = useRef(false);

  useEffect(() => {
    const match = value.match(/(\d+)/);
    if (!match) { setDisplay(value); return; }
    const target = parseInt(match[1], 10);
    if (target === 0) { setDisplay(value); return; }
    const prefix = value.slice(0, match.index);
    const suffix = value.slice((match.index || 0) + match[1].length);

    // Hareket azaltma tercihine saygı: animasyonsuz göster
    if (typeof window !== 'undefined' && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      setDisplay(value);
      return;
    }

    setDisplay(`${prefix}0${suffix}`);
    const el = ref.current;
    if (!el) return;

    const observer = new IntersectionObserver((entries) => {
      if (!entries[0].isIntersecting || started.current) return;
      started.current = true;
      const duration = 1200;
      const startTime = performance.now();
      const tick = (now: number) => {
        const t = Math.min((now - startTime) / duration, 1);
        const eased = 1 - Math.pow(1 - t, 3); // easeOutCubic
        setDisplay(`${prefix}${Math.round(target * eased)}${suffix}`);
        if (t < 1) requestAnimationFrame(tick);
      };
      requestAnimationFrame(tick);
      observer.disconnect();
    }, { threshold: 0.4 });

    observer.observe(el);
    return () => observer.disconnect();
  }, [value]);

  return (
    <div
      ref={ref}
      className="text-5xl font-black mb-2 text-glow-cyan"
      style={{ fontFamily: 'var(--font-heading)', color: '#FFB020' }}
    >
      {display}
    </div>
  );
}

// index.tsx'ten ayrıştırıldı — landing "Stats" bölümü
export default function Stats({ L }: any) {
  return (
    <>
        <section className="py-12 md:py-16 relative">
          <div className="divider-glow mb-16 mx-12" />
          <div className="max-w-5xl mx-auto px-6">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              {L.stats.map((s: any, i: number) => (
                <div
                  key={i}
                  className={`reveal reveal-delay-${i + 1} glass-panel rounded-2xl p-8 text-center gradient-border tilt-card`}
                >
                  <CountUpValue value={s.value} />
                  <div className="text-sm text-gray-400">{s.label}</div>
                </div>
              ))}
            </div>
          </div>
        </section>

    </>
  );
}
